<h1 class="text-2xl font-bold text-gray-700">Todos</h1>

<div class="shadow px-6 mt-3 pb-4 bg-white">
  <ng-content></ng-content>
</div>
